"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Halfboard = function Halfboard(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "32",
    height: "48",
    viewBox: "0 0 32 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30347 4.35718C3.30347 3.94296 2.96768 3.60718 2.55347 3.60718C2.13925 3.60718 1.80347 3.94296 1.80347 4.35718V15.0715C1.80347 16.4719 2.93874 17.6072 4.33918 17.6072H5.82132V30.2336H3.53132C2.82361 30.2336 2.2499 30.8073 2.2499 31.515V43.1537C2.2499 44.5295 2.90463 45.8232 4.01327 46.638C5.53559 47.7568 7.60876 47.7566 9.13178 46.6401C10.2436 45.825 10.9017 44.5282 10.9017 43.1491V31.5142C10.9017 30.8069 10.3283 30.2336 9.62101 30.2336H7.32132V17.6072H8.80347C10.2039 17.6072 11.3392 16.4719 11.3392 15.0715V4.35718C11.3392 3.94296 11.0034 3.60718 10.5892 3.60718C10.175 3.60718 9.83918 3.94296 9.83918 4.35718V15.0715C9.83918 15.6435 9.37548 16.1072 8.80347 16.1072H7.32132V4.35718C7.32132 3.94296 6.98554 3.60718 6.57132 3.60718C6.15711 3.60718 5.82132 3.94296 5.82132 4.35718V16.1072H4.33918C3.76717 16.1072 3.30347 15.6435 3.30347 15.0715V4.35718ZM3.7499 43.1537V31.7336H6.57132H9.40168V43.1491C9.40168 44.0498 8.97171 44.8975 8.24493 45.4303C7.24972 46.1599 5.89528 46.1596 4.90157 45.4293C4.17751 44.8972 3.7499 44.0522 3.7499 43.1537ZM31.4285 4.78209C31.4285 4.22651 30.8673 3.84661 30.3515 4.05294C24.7035 6.31215 20.9999 11.7824 20.9999 17.8655V29.3776C20.9999 30.4795 21.8932 31.3728 22.9951 31.3728H23.6785V43.2749C23.6785 44.5394 24.2742 45.73 25.2862 46.4882L25.5007 46.649C26.9755 47.7539 29.038 47.6073 30.3417 46.305C31.0375 45.6099 31.4285 44.6668 31.4285 43.6833V30.6228V4.78209ZM25.1785 43.2749V31.3728H29.9285V43.6833C29.9285 44.2687 29.6958 44.8301 29.2816 45.2438C28.5056 46.019 27.2779 46.1062 26.4001 45.4485L26.1856 45.2878C25.5516 44.8128 25.1785 44.067 25.1785 43.2749ZM29.9285 5.88388V29.8728H24.4285H22.9951C22.7216 29.8728 22.4999 29.6511 22.4999 29.3776V17.8655C22.4999 12.756 25.4059 8.12728 29.9285 5.88388Z",
    fill: fill
  }));
};
Halfboard.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Halfboard.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Halfboard;